export default __webpack_public_path__ + "static/media/design_style_education.ca1d5cd9.svg";